import { render, staticRenderFns } from "./casino-main.vue?vue&type=template&id=83e9703c"
import script from "./casino-main.vue?vue&type=script&lang=js"
export * from "./casino-main.vue?vue&type=script&lang=js"
import style0 from "./casino-main.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/casino-home/casino-main.vue
// module id = J2LQ
// module chunks = 0